import { useMutation, useQueryClient } from '@tanstack/react-query';
import { postApiPdfTemplatesV1BlocksIdUnarchive } from '@/generated/api/blocks/blocks';
import { parseBlockApiId } from '@/blocks/application/helpers/parseBlockApiId';
import { SUPPRESS_GLOBAL_ERROR_TOAST } from '@/common/application/constants/mutationMeta';
import { blocksQueryKey } from '@/blocks/application/hooks/useBlocks';

/**
 * Restores an archived block via `POST /blocks/{id}/unarchive`.
 * Mirrors `useUnarchiveTemplate` (generated Orval client + query invalidation).
 */
export const useUnarchiveBlock = () => {
  const queryClient = useQueryClient();

  return useMutation({
    meta: SUPPRESS_GLOBAL_ERROR_TOAST,
    mutationFn: async (id: string): Promise<void> => {
      await postApiPdfTemplatesV1BlocksIdUnarchive(parseBlockApiId(id));
    },
    onSuccess: async (_data, blockId) => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: blocksQueryKey,
          refetchType: 'all'
        }),
        queryClient.invalidateQueries({
          queryKey: ['document-builder', 'block', blockId]
        })
      ]);
    }
  });
};
